import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-152">
      <FadeIn data-id="element-153">
        <div className="space-y-6 text-xl md:text-2xl text-slate-300 leading-relaxed font-light" data-id="element-154">
          <p data-id="element-155">
            <strong className="text-white font-medium" data-id="element-156">
              Estás sentado frente a la pantalla.
            </strong>{' '}
            Sabes exactamente lo que tienes que hacer. Tienes la lista escrita,
            el café servido y el tiempo por delante. Pero no puedes moverte.
          </p>
          <p data-id="element-157">
            Sientes un peso invisible en el pecho. Mientras el reloj avanza, tu
            ansiedad sube y tu autoestima baja. Te dices que eres vago, que no
            tienes disciplina, que "mañana será diferente".
          </p>
          <p className="text-amber-400 font-medium" data-id="element-158">
            Pero la verdad es que estás atrapado en el limbo de la parálisis
            ejecutiva.
          </p>
        </div>
      </FadeIn>
    </section>;
}